import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import PodcastEpisodeForm from './forms/PodcastEpisodeForm';
import PodcastEpisodeList from './lists/PodcastEpisodeList';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {getComponentConfig} from "../../utils/components";
import {isEqual} from "lodash-es";

class PodcastEpisodeEditor extends React.Component {

    state = {
        createType: null,
        lastCreateType: null,
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Epizódok"}
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <PodcastEpisodeList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Epizódok adatai"}
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}
                >
                    <PodcastEpisodeForm
                        {...this.props}
                        resetType={() => {
                            this.setState({createType: null, lastCreateType: null});
                        }}
                        createType={this.state.createType}
                        lastCreateType={this.state.lastCreateType}
                        setCreateType={async (createType) => {
                            if (createType) {
                                if (createType !== this.props.lastCreateType) {
                                    await this.pristineForm();
                                }
                                this.setState({createType, lastCreateType: createType});
                            } else {
                                this.setState({createType});
                            }
                        }}
                    />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({
    componentName: "PodcastEpisode",
    WrappedComponent: PodcastEpisodeEditor,
    dirtyFlag: (values, initialValues) => {
        values = {...values};
        let events = values.events;
        delete values.events;
        if (isEqual(values, initialValues)) {
            if ((events || []).length) {
                return true;
            }
        } else {
            return true;
        }
        return false;
    },
    props: {
        view: "admin",
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            if (data.events) {
                data.locations = data.locations || [];
                data.events.map((event) => {
                    data.locations = [...(data.locations || []), ...(event.locations || [])];
                });
            }
            if (componentConfig.fielddefs.locations && data.locations) {
                const config = await getComponentConfig(componentConfig.fielddefs.locations.objects);
                data.locations = data.locations.map((location) => {
                    if (location instanceof Object) {
                        return location?.[config.idfield];
                    } else {
                        return location;
                    }
                }).filter(Boolean).filter((item, pos, self) => self.indexOf(item) === pos);
            }
            return {action, data, params};
        }
    }
});